var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-pagination',{staticClass:"pagination",attrs:{"background":"","current-page":_vm.currentPageC,"page-size":_vm.currentPageSizeC,"layout":"total, prev, pager, next, jumper","total":_vm.totalC},on:{"current-change":_vm.currentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }